import Dexie, { Table } from 'dexie';

interface ISiteData {
  id?: number | string;
  data: any;
}

interface IPasswordData {
  site_id: string;
  password: string;
}

interface IUserData {
  site_id: string;
  appInstallationState?: string;
  appInstallationTrackedWithGA?: boolean;
  confirmedSingleImgDlHint?: boolean;
}

// Database class extending Dexie
class ScrappbookDatabase extends Dexie {
  sites!: Table<ISiteData>;

  passwords!: Table<IPasswordData>;

  user!: Table<IUserData>;

  constructor() {
    super('database');

    this.version(4).stores({
      sites: '++id, data',
      passwords: '++site_id, password',
      user: '++site_id, appInstallationState, appInstallationTrackedWithGA, confirmedSingleImgDlHint'
    });

    this.version(3).stores({
      sites: '++id, data',
      passwords: '++site_id, password',
      user: '++site_id, appInstallationState, confirmedSingleImgDlHint'
    });

    this.version(2).stores({
      sites: '++id, data',
      passwords: '++site_id, password'
    });
  }
}

const db = new ScrappbookDatabase();

export default db;
export type { ISiteData, IPasswordData, IUserData };
